module.exports = __webpack_public_path__ + "static/media/rappers_on_rise.d9b83e10.avif";